import { z } from "zod";

export const schema = z.object({
    title: z.string().min(1, "forms.general-validation.title_required"),
    description: z.string().optional(),
});

export type CommissionGroupData = z.infer<typeof schema>;
